import { ca } from '@cian/analytics';

export const getProblematicLabel = (type: string) => {
  switch (type) {
    case 'problem':
      return 'red';
    case 'reliable':
      return 'green';
    default:
      return null;
  }
};

// Клик по иконке "Проблемно"/"Надежно" в выдаче ЖК
export const trackProblemMoreButtonClick = (type: string, GKId: number) => {
  const label = getProblematicLabel(type);

  if (!label) {
    return;
  }

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'JK_problems_more_click',
    label: `${label}/${GKId}`,
  });
};

// Ховер на иконку "Проблемно"/с в выдаче ЖК
export const trackProblemIconHover = (type: string, GKId: number) => {
  const label = getProblematicLabel(type);

  if (!label) {
    return;
  }

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'JK_problems_icon_hover',
    label: `${label}/${GKId}`,
  });
};
